import { render, staticRenderFns } from "./StatusBadge.vue?vue&type=template&id=572b6dcc&scoped=true&lang=pug"
import script from "./StatusBadge.vue?vue&type=script&lang=ts"
export * from "./StatusBadge.vue?vue&type=script&lang=ts"
import style0 from "./StatusBadge.vue?vue&type=style&index=0&id=572b6dcc&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "572b6dcc",
  null
  
)

/* custom blocks */
import block0 from "./StatusBadge.i18n.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Frunner%2Fwork%2Fcompliance-nationbetter-uk%2Fcompliance-nationbetter-uk%2Fsrc%2Fcomponents%2FStatusBadge%2FStatusBadge.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports